export const testPassword = (value = '') => value.length >= 8 && /\d/.test(value) && /[A-Z]/.test(value);
